import { render, staticRenderFns } from "./TariffMandatoryItemFormDialog.vue?vue&type=template&id=284db7d5&"
import script from "./TariffMandatoryItemFormDialog.vue?vue&type=script&lang=ts&"
export * from "./TariffMandatoryItemFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports